<template>
    <div class="container">
        <div class="masonry">
            <div v-if="isPending" v-for="(item, index) in items" class="masonry-item flex">
                <AppSkeleton
                    :custom-size="index / 2 === 0 ? 'w-[276px] h-[207px]' : 'w-[276px] h-[414px]'"
                    type="square"
                >
                </AppSkeleton>
            </div>
            <div v-else v-for="(item, index) in randomNumber" :key="index + random" class="masonry-item">
                <NuxtLinkLocale v-if="item !== selectedItem - 1" class="" :to="`/ideas/${landingTitle}/${item + 1}`">
                    <div class="shadow mb-2">
                        <NuxtImg
                            placeholder
                            :placeholder-class="
                                index / 2 === 0
                                    ? 'p-2 loading rounded-lg bg-gray-900 w-[276px] h-[207px]'
                                    : 'p-2 loading rounded-lg bg-gray-900 w-[276px] h-[414px]'
                            "
                            v-show="!isPending"
                            @load="load"
                            id="masonry"
                            class="rounded-2xl bg-center object-cover"
                            :src="items[item][`image_${item + 1}`]"
                            alt="Image 1"
                        />
                    </div>
                    <div class="flex justify-between">
                        <p class="text-body-md text-gray-300 font-bold truncate max-w-48">
                            {{ items[item][`image_${item + 1}_caption`] }}
                        </p>
                        <Icon name="tabler:chevron-right" class="text-gray-300 w-6 h-6" />
                    </div>
                </NuxtLinkLocale>
                <div
                    v-if="item === 10"
                    class="masonry-item relative bg-[url('/images/bg-advertised.png')] bg-cover object-contain bg-no-repeat lg:h-[460px] h-[280px] rounded-2xl"
                >
                    <div
                        class="absolute rounded-2xl bg-black h-full w-full bg-opacity-40 flex flex-col space-y-2 items-center text-center justify-center px-4"
                    >
                        <Icon name="tabler:upload" class="lg:w-12 lg:h-12 w-6 h-6 text-gray-100" />
                        <h3 class="text-gray-100 lg:text-title-sm text-body-md font-bold">
                            Click to preview this style in your own space!
                        </h3>
                        <p class="text-body-sm text-gray-300 leading-4 mb-6">
                            Upload a photo of your room to preview this exact style on your space with just a click
                            using our AI!
                        </p>
                        <NuxtLinkLocale to="/dashboard/services">
                            <AppButton class="whitespace-nowrap" variant="primary" size="sm" color="white">
                                Preview for Free!
                            </AppButton>
                        </NuxtLinkLocale>
                    </div>
                </div>
                <div
                    v-if="index === 1 || index === 10"
                    class="masonry-item background-purple relative overflow-hidden py-6 px-4 rounded-2xl"
                >
                    <NuxtLinkLocale to="/dashboard/services">
                        <div class="flex items-center justify-between">
                            <img class="absolute right-0 top-0" src="/images/stars-banner.png" />
                            <h3
                                class="lg:text-title-sm text-body-md font-bold text-gray-100 max-w-[120px] lg:max-w-[146px] relative z-30"
                            >
                                Click to preview this style in your own space!
                            </h3>
                            <Icon name="tabler:chevron-right" class="w-10 h-10 text-gray-100" />
                        </div>
                    </NuxtLinkLocale>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup lang="ts">
interface Props {
    items: any;
    selectedItem?: any;
}

const props = defineProps<Props>();

const landingTitle = useRoute().params.landing;
const random = Math.floor(Math.random() * props.items.length);
const randomNumber = ref<number[]>([]);
let maxLength = props.items.length;
for (let index = 0; index < maxLength; index++) {
    let landing: number = Math.floor(Math.random() * props.items.length);
    if (randomNumber.value.length === props.items.length) break;
    if (!randomNumber.value.includes(landing)) randomNumber.value.push(landing);
    else {
        maxLength++;
    }
}
const isPending = ref(true);
function load() {
    setTimeout(() => {
        isPending.value = false;
    }, 2000);
}

onMounted(() => {
    load();
});
</script>
<style>
@import "~/assets/scss/app-skeleton/app-skeleton.scss";
/* Necessary styles for masonry layout */
@media screen and (max-width: 800px) {
    .masonry {
        column-count: 2; /* Adjust this value to change the number of columns */
        column-gap: 1rem; /* Adjust the gap between columns */
    }
}
@media screen and (min-width: 800px) {
    .masonry {
        column-count: 4; /* Adjust this value to change the number of columns */
        column-gap: 1rem; /* Adjust the gap between columns */
    }
}

.masonry-item {
    break-inside: avoid; /* Prevent items from breaking inside columns */
    margin-bottom: 1rem; /* Adjust the gap between rows */
}
.background-purple {
    background: linear-gradient(241deg, #7878cd 40.15%, rgba(77, 77, 189, 0) 118.34%);
}
.background-purple {
    background: linear-gradient(241deg, #7878cd 40.15%, rgba(77, 77, 189, 0) 118.34%);
}
</style>
